<template>
    <div class="container pt-2">
        <PageTitle main="Relatório de Transportes por Cliente" sub="" />
        <div class="row">
            <div class="col-md-12">
                <b-form-group label="Cliente:" label-for="cliente">
                    <b-form-select id="cliente" :options="clientes"
                        v-model="temp.id"
                        @change="loadCliente()"
                        placeholder="Informe o nome do cliente."
                        class="textInput"/>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-md-center" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <b-button variant="success" block class="mt-2 mb-2 botaoInput" @click="callReport" v-if="!visualizaReport && !isLoading">Gerar Relatório</b-button>
        <hr v-if="!visualizaReport">
        <b-button variant="warning" block class="mt-2 mb-2 botaoInput" :href="link" v-if="visualizaReport">Salvar</b-button>
        <hr v-if="visualizaReport">
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields">
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
        <div v-else>
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields" >
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'

export default {
    name: 'TransportesByCliente',
    components: { PageTitle },
    data: function() {
        return {
            larguraTela: 0,
            overflowValue: 'auto',
            visualizaReport: false,
            isLoading: false,
            link: '',
            cliente: {},
            clientes: [],
            rep: {},
            temp: {},
            exibeRodape: true,
            transportes: [],
            fields: [
                { key: 'rastreio', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data_inicio', label: 'Início', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data_final', label: 'Previsão', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' }
            ]
        }
    },
    methods: {
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadTransportes(nome) {
            const url = `${baseApiUrl}/backend/logByCliente.php?cliente=${nome}`
            axios.get(url).then(res => {
                this.transportes = res.data
                if(this.transportes.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        callReport() {
            this.isLoading = true
            const url = `${baseApiUrl}/backend/repTransportesByCliente.php?cliente=${this.cliente.id}&cliente_nome=${this.cliente.nome}`
            axios.get(url).then((res) => {
                this.isLoading = false
                this.visualizaReport = true
                this.link = res.data['result']
            })
        },
        loadClientes() {
            const url = `${baseApiUrl}/backend/clientes.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.clientes = res.data.map(cliente => {
                        return { ...cliente, value: cliente.id, text: cliente.nome }
                    })
                }else{
                    this.clientes.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadCliente() {
            const url = `${baseApiUrl}/backend/clientes.php?id=${this.temp.id}`
            axios.get(url).then(res => {
                this.cliente = res.data[0]
                this.loadTransportes(this.cliente.nome)
            })
        }
    },
    mounted() {
        this.loadClientes()
        this.exibeRodape = true
        this.visualizaReport = false
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
</style>